/**
 * Update the poster image based on screen size.
 * If the mobile or tablet image is not available, fallback to the desktop image.
 *
 * @param {HTMLElement} videoWrapper - The wrapper element containing the video.
 */
export function updatePosterImage(videoWrapper) {
  const posterImageContainer = videoWrapper.querySelector('.pr-video__poster-image-container img');
  const posterMobile = videoWrapper.getAttribute('data-poster-mobile');
  const posterTablet = videoWrapper.getAttribute('data-poster-tablet');
  const posterDesktop = videoWrapper.getAttribute('data-poster-desktop');

  if (posterImageContainer && posterDesktop) {
    const screenWidth = window.innerWidth;

    if (screenWidth <= 768) { // Mobile
      posterImageContainer.src = posterMobile || posterTablet || posterDesktop;
    } else if (screenWidth <= 1024) { // Tablet
      posterImageContainer.src = posterTablet || posterDesktop;
    } else { // Desktop
      posterImageContainer.src = posterDesktop;
    }
  }
}
